module.exports = __webpack_public_path__ + "static/moteur-39b63c1c9931948413ae4627106f85e9.png";